"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusCode = void 0;
var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["OK"] = 0] = "OK";
    StatusCode[StatusCode["PAD_DISCONNECTED"] = 1] = "PAD_DISCONNECTED";
    StatusCode[StatusCode["CONNECTION_LOST"] = 2] = "CONNECTION_LOST";
    StatusCode[StatusCode["REBOOT"] = 3] = "REBOOT";
    StatusCode[StatusCode["INCOMPATIBLE_MATS"] = 4] = "INCOMPATIBLE_MATS";
    StatusCode[StatusCode["INCOMPATIBLE_BLACK_BOX"] = 5] = "INCOMPATIBLE_BLACK_BOX";
    StatusCode[StatusCode["FIRMWARE_UPDATE"] = 6] = "FIRMWARE_UPDATE";
    StatusCode[StatusCode["WAITING__STATUS"] = 7] = "WAITING__STATUS";
})(StatusCode = exports.StatusCode || (exports.StatusCode = {}));
